module.exports = __webpack_public_path__ + "img/amx-4.bf049d30.webp";